import React from "react";
import AboutHero from "../components/about/AboutHero";
import AboutContent from "../components/about/AboutContent";

const AboutPage = () => {
  return (
    <main className="pt-20">
      <AboutHero />
      <AboutContent />
    </main>
  );
};

export default AboutPage;
